import { NavLink } from 'react-router-dom';
import { LayoutDashboard, ClipboardList, ClipboardCheck, Gauge, Truck, Wrench, Receipt, Wallet, FolderArchive, Hammer, Package } from 'lucide-react';

const TABS = [
  { to: '', label: 'Tableau de bord', icon: LayoutDashboard, end: true },
  { to: 'bons', label: 'Bons de travail', icon: ClipboardList },
  { to: 'inspections', label: 'Inspections', icon: ClipboardCheck },
  { to: 'mesures', label: 'Mesures pneus / freins', icon: Gauge },
  { to: '/admin/fleet', label: 'Véhicules', icon: Truck, external: true },
  { to: '/admin/maintenance', label: 'Entretiens', icon: Wrench, external: true },
  { to: 'inventaire', label: 'Inventaire', icon: Package },
  { to: 'facturation', label: 'Facturation', icon: Receipt },
  { to: 'depenses', label: 'Dépenses', icon: Wallet },
  { to: 'audit', label: 'Dossier SAAQ', icon: FolderArchive },
  { to: '/admin/atelier', label: 'Atelier', icon: Hammer, external: true },
];

export const MecanicienTabs = () => (
  <nav className="flex gap-1 overflow-x-auto border-b border-slate-800 mb-4 -mx-1 px-1 print:hidden" data-testid="mecanicien-tabs">
    {TABS.map(({ to, label, icon: Icon, end, external }) => (
      <NavLink
        key={label}
        to={external ? to : `/admin/mecanicien${to ? `/${to}` : ''}`}
        end={end}
        className={({ isActive }) => `flex items-center gap-1.5 px-3 py-2.5 text-xs font-semibold whitespace-nowrap border-b-2 transition-colors ${
          isActive ? 'border-amber-500 text-amber-400' : 'border-transparent text-slate-400 hover:text-white'
        }`}
        data-testid={`mecanicien-tab-${(to || 'accueil').replace(/\//g, '-').replace(/^-/, '')}`}
      >
        <Icon size={14} /> {label}
      </NavLink>
    ))}
  </nav>
);
